import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Modal from "@mui/material/Modal";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import RegisterUserForm from "./Register";
import { useEffect, useState } from "react";
import LoginUserForm from "./Login";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useTheme } from "../../../contexts/ThemeContext";
import { useAuthModal } from "../../../contexts/AuthModalContext";

export default function AuthModal({ handleClose, open }) {
  const [showLogin, setShowLogin] = useState(false);
  const { auth } = useSelector((store) => store);
  const navigate = useNavigate();
  const { isDarkMode } = useTheme();
  const { executePendingAction } = useAuthModal();

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: { xs: "90%", sm: 400, md: 500 },
    bgcolor: isDarkMode ? '#1a1a1a' : '#ffffff',
    boxShadow: isDarkMode ? '0 8px 32px rgba(0, 0, 0, 0.8)' : '0 8px 32px rgba(0, 0, 0, 0.15)',
    p: { xs: 2, md: 4 },
    borderRadius: 2,
    maxHeight: "90vh",
    overflowY: "auto",
    border: isDarkMode ? '1px solid rgba(255, 255, 255, 0.1)' : 'none',
    backdropFilter: 'none',
  };

  useEffect(() => {
    if (auth.user) {
      // Execute any pending action after successful login
      executePendingAction();
      
      handleClose();
      
      if (auth.user?.role === "ADMIN") {
        navigate("/admin");
      }
    }
  }, [auth.user]);

  return (
<Modal
  open={open}
  onClose={handleClose}
  aria-labelledby="modal-modal-title"
  aria-describedby="modal-modal-description"
  className="modal-overlay"
>
  <Box sx={style}>
    <IconButton
      onClick={handleClose}
      sx={{
        position: 'absolute',
        right: 8,
        top: 8,
        color: isDarkMode ? 'rgba(255, 255, 255, 0.7)' : 'grey.500',
        bgcolor: isDarkMode ? 'rgba(255, 255, 255, 0.1)' : 'grey.100',
        '&:hover': { 
          bgcolor: isDarkMode ? 'rgba(255, 255, 255, 0.2)' : 'grey.200' 
        },
        width: 32,
        height: 32
      }}
    >
      <CloseIcon fontSize="small" />
    </IconButton>
    {showLogin ? (
      <LoginUserForm onSwitchToRegister={() => setShowLogin(false)} />
    ) : (
      <RegisterUserForm onSwitchToLogin={() => setShowLogin(true)} />
    )}
  </Box>
</Modal>

  );
}
